import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { MapDrawControlMode, MapDrawControlModes, MapDrawMode } from '../types/app';
import { GeoPlace } from '../types/geoModels';

export function isDrawControlMode(drawMode: MapDrawMode | string): drawMode is MapDrawControlMode {
  return MapDrawControlModes.includes(drawMode as MapDrawControlMode);
}

export const getPastelColor = () => {
  return 'hsl(' + 360 * Math.random() + ',' + (25 + 70 * Math.random()) + '%,' + (55 + 10 * Math.random()) + '%)';
};

export function isGeoPlace(obj: unknown): obj is GeoPlace {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'point' in obj &&
    'address' in obj &&
    typeof (obj as any).address === 'string' &&
    typeof (obj as any).point === 'object' &&
    (obj as any).point !== null &&
    typeof (obj as any).point.lat === 'number' &&
    typeof (obj as any).point.lng === 'number'
  );
}

export function geometryIsPolygon(geometry: GeoJSON.Geometry): geometry is GeoJSON.Polygon {
  return geometry.type === 'Polygon';
}

export function isValidSafegptAlarmPoint(lng?: number, lat?: number) {
  if (lat === undefined || lng === undefined) return false;
  if (!lat && !lng) return false;
  return isValidLatitude(lat) && isValidLongitude(lng);
}
